var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconComputerStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,62.70215H39.25V65.25H31.5459v1.5H48.4541v-1.5H40.75V62.70215H68a2.7528,2.7528,0,0,0,2.75-2.75V28.083A2.7528,2.7528,0,0,0,68,25.333H64v1.5h4a1.25116,1.25116,0,0,1,1.25,1.25V55.25H10.75V28.083A1.25116,1.25116,0,0,1,12,26.833h4v-1.5H12a2.7528,2.7528,0,0,0-2.75,2.75V59.95215A2.7528,2.7528,0,0,0,12,62.70215ZM10.75,56.75h58.5v3.20215a1.25116,1.25116,0,0,1-1.25,1.25H12a1.25116,1.25116,0,0,1-1.25-1.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25,20V30a.7502.7502,0,0,0,.75.75H60a.7502.7502,0,0,0,.75-.75V20h-1.5v9.25H20.75V20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25,8V20.18945l-4.71973-4.71972-1.06054,1.06054,6,6a.74971.74971,0,0,0,1.06054,0l6-6-1.06054-1.06054L40.75,20.18945V8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComputerStorage);
export default __webpack_public_path__ + "static/media/icon_computer_storage.f8019d7b2ab740fc7499c3cc7c705495.svg";
export { ForwardRef as ReactComponent };